import type { PayoutRule } from "../api/types";

/**
 * Human summary of a payout rule's parameters. Only for surfaces that may
 * show rule parameters: owner pages (§4.5) and the courier's OWN rule
 * (Orders.md §16.6 — deliberate asymmetry). Never render this for managers.
 */
export function ruleSummary(rule: PayoutRule | null): string {
  if (!rule) return "No rule — assignment needs a manual payout";
  const min = rule.minPayoutEur ? ` · min ${rule.minPayoutEur} €` : "";
  switch (rule.kind) {
    case "PERCENT":
      return `${rule.name} — ${rule.percent}% of the delivery fee${min}`;
    case "FLAT":
      return `${rule.name} — ${rule.flatEur} € per delivery${min}`;
    case "PER_KM":
      return `${rule.name} — ${rule.ratePerKmEur} €/km${
        rule.baseFeeEur ? ` + ${rule.baseFeeEur} € base` : ""
      }${min}`;
    default:
      return rule.name;
  }
}
